import { ReadyChangeCallback, Session } from '../session-manager';
import { env_vars } from '../../load-env';
import { JegerwebApiService } from '../../../services/api-service/jegerweb-api-service';
import i18n from '../../i18n';

export interface BasicAuthUserInfo {
  hunterid: string;
  birthdate: string;
}

const BASIC_AUTH_KEY = 'basic_auth_info';

export class BasicAuthSession implements Session {
  userInfo?: BasicAuthUserInfo;
  isLoading = true;

  readyChangeSubs: ReadyChangeCallback[] = [];

  async start() {
    this.isLoading = true;
    this.getUserInfo();

    if (!this.userInfo) {
      this.readyChange();
      window.location.pathname = '/utenlandsk/login';
      return false;
    }

    this.isLoading = false;
    this.readyChange();
    return true;
  }

  async end() {
    try {
      await JegerwebApiService.get('/jeger/utenlandsk/nb', {
        auth: { username: '', password: '' }
      });
    } catch {
      // ignore – vi bare invaliderer session
    }

    localStorage.removeItem(BASIC_AUTH_KEY);

    // CRA + gammel setup → ts-ignore er ok her
    // @ts-ignore
    window.location.href = env_vars.OIDC_POST_LOGOUT_REDIRECT_URI;
  }

  async signin(basicAuthUserInfo: BasicAuthUserInfo) {
    this.isLoading = true;
    this.readyChange();

    try {
      await JegerwebApiService.get('/jeger/utenlandsk/nb', {
        auth: {
          username: basicAuthUserInfo.hunterid,
          password: basicAuthUserInfo.birthdate
        }
      });

      this.userInfo = basicAuthUserInfo;
      localStorage.setItem(BASIC_AUTH_KEY, JSON.stringify(basicAuthUserInfo));

    } catch (error: any) {
      console.error(error);

      const status = error?.response?.status;

      // 👉 Ingen response = CORS / nettverksfeil
      if (!status) {
        throw new Error('Tilkoblingsfeil (CORS eller nettverk)');
      }

      if (status === 401) {
        throw new Error(
            i18n.t('basicAuthLogin:jegernrSkalBestataAv6Eller8Siffer')
        );
      }

      throw new Error('Noe gikk galt. Prøv på nytt senere');

    } finally {
      this.isLoading = false;
      this.readyChange();
    }
  }

  isValid() {
    return !!this.userInfo;
  }

  isReady() {
    return this.isValid() && !this.isLoading;
  }

  addReadyChangeListener(readyCallback: (ready: boolean) => void) {
    this.readyChangeSubs.push(readyCallback);
  }

  readyChange() {
    const ready = this.isReady();
    this.readyChangeSubs.forEach(callback => callback(ready));
  }

  getUserInfo() {
    if (!this.userInfo) {
      const storedInfo = localStorage.getItem(BASIC_AUTH_KEY);
      if (storedInfo) {
        try {
          this.userInfo = JSON.parse(storedInfo);
        } catch {
          localStorage.removeItem(BASIC_AUTH_KEY);
        }
      }
    }
    return this.userInfo;
  }
}
